import { loadStripe } from '@stripe/stripe-js';

export const stripePromise = loadStripe(
    'pk_test_51P5F8tP6SNCLj6dr9ihYwCWlZclPn70582Ama63vadinFJepWlPjR5ebFdwrWPw4vrOTkHZ2SyJCwc28JQZMq4WP00B6hKXhwq',
);